import styled from "styled-components";
import color from "../../assets/css/colors";

export const TheadComponent = styled.thead`
    background: ${color.grayLight} 0% 0% no-repeat padding-box;
    height: 34px;
    opacity: 1;
`;